import { BarcodeTrackingRow, TrackingMode, TrackingSearch } from "./types";

export const initialTrackingSearch: TrackingSearch = {
  facilityId: 0,
};

export const trackingSortById = {
  clickedIconData: "Id",
  sortingOrder: "desc",
};

export const buildTrackingPayload = ({
  mode,
  pageNumber,
  pageSize,
  search,
  sort,
}: {
  mode: TrackingMode;
  pageNumber: number;
  pageSize: number;
  search: TrackingSearch;
  sort: { clickedIconData: string; sortingOrder: string };
}) => ({
  pageNumber,
  pageSize,
  queryModel: {
    facilityId: Number(search.facilityId) || 0,
    isCompleted: mode === "completed",
  },
  sortColumn: sort.clickedIconData,
  sortDirection: sort.sortingOrder,
});

export const normalizeStatusKey = (status?: string | null) =>
  `${status ?? ""}`.toLowerCase().replace(/[^a-z0-9]/g, "");

export const getTrackingStatusClassName = (status?: string | null) => {
  const statusClassMap: Record<string, string> = {
    pendingshipment: "badge-status-pending",
    shipped: "badge-status-shipped",
    intransit: "badge-status-in-transit",
    received: "badge-status-success",
    closed: "badge-status-completed",
    rejected: "badge-status-rejected",
  };

  return statusClassMap[normalizeStatusKey(status)] || "badge-status-default";
};

export const getBarcodeNumber = (row: BarcodeTrackingRow) =>
  `${row.barcode ?? row.barCode ?? row.barcodeNo ?? row.barcodeNumber ?? row.value ?? ""}`;

export const getGeneratedDate = (row: BarcodeTrackingRow) =>
  row.barcodeGeneratedDate ??
  row.generatedDate ??
  row.genratedDate ??
  row.createdDate ??
  null;

export const getGeneratedBy = (row: BarcodeTrackingRow) =>
  row.barcodeGeneratedBy ??
  row.generatedBy ??
  row.genratedBy ??
  row.createdBy ??
  "";

export const getClosureDate = (row: BarcodeTrackingRow) =>
  row.closureDate ?? row.closedDate ?? row.rejectedDate ?? null;

export const getTrackingRowsAndTotal = (response: any) => {
  const root = response?.data;
  const data = root?.data ?? root;
  const rows =
    (Array.isArray(data) && data) ||
    (Array.isArray(data?.records) && data.records) ||
    (Array.isArray(data?.items) && data.items) ||
    (Array.isArray(root?.items) && root.items) ||
    [];

  return {
    rows,
    total: root?.total ?? data?.total ?? data?.totalCount ?? rows.length,
  };
};
